module.exports = __webpack_public_path__ + "static/media/03_atw_weihnachtskarte.3f0ffa71.svg";